// Link-Baustein der Anwendung für das UI-Kit (<UiProvider link={RouterLink}>): Pfade innerhalb der App wechseln
// ohne Neuladen; alles andere (fremde Adressen, mailto:, Sprungmarken) bleibt ein gewöhnlicher Link. Ein Verweis mit
// download-Angabe wird ein DownloadLink (in der Merxo-App: Datei mit der Sitzung holen und teilen). In der App öffnet
// ⌘-/Strg-/Umschalt-Klick (iPad mit Tastatur) kein neues Fenster – iOS gäbe es an Safari ohne Sitzung (§5.2).
import type { MouseEvent } from 'react'
import { Link, useNavigate } from 'react-router'
import { DownloadLink } from '../api/files'
import { nativeApp } from '../lib/native'
import type { LinkProps } from '../ui/context'

const isInternal = (href: string): boolean => href.startsWith('/') && !href.startsWith('//')

export function RouterLink({ href, download, onClick, children, ...rest }: LinkProps) {
  const navigate = useNavigate()
  if (download !== undefined && download !== false) {
    return (
      <DownloadLink href={href} fileName={typeof download === 'string' && download ? download : null} onClick={onClick} {...rest}>
        {children}
      </DownloadLink>
    )
  }
  if (!isInternal(href) || rest.target === '_blank') {
    return (
      <a href={href} onClick={onClick} {...rest}>
        {children}
      </a>
    )
  }
  const handleClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    onClick?.(event)
    if (event.defaultPrevented || !nativeApp()) return
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      event.preventDefault()
      void navigate(href)
    }
  }
  return (
    <Link to={href} onClick={handleClick} {...rest}>
      {children}
    </Link>
  )
}
